"use client";

import React from "react";
import { OakFlex } from "@oaknational/oak-components";

import { ListHeader, LessonList } from "@/components";
import type { LessonListItem, ProgrammeFields, UnitData } from "@/types/ui";

type Props = {
  browseData?: LessonListItem[];
  programmeSlug: string;
  unitData?: UnitData;
  programmeFields?: ProgrammeFields;
  headerLeftSlot?: React.ReactElement;
  programmeUrlTemplate: string;
  pupilLessonUrlTemplate: string;
  onLessonSelected?: (lessonSlug: string) => void;
  onLessonPreviewed?: (lessonSlug: string) => void;
};
export const LessonListingView = ({
  browseData,
  programmeSlug,
  unitData,
  programmeFields,
  headerLeftSlot,
  programmeUrlTemplate,
  pupilLessonUrlTemplate,
  onLessonSelected,
  onLessonPreviewed,
}: Props) => {
  const hasOptionality = !!programmeFields?.optionality;
  const getPupilLessonUrl = (
    programmeSlug: string,
    unitSlug: string,
    lessonSlug: string,
  ) =>
    pupilLessonUrlTemplate
      .replace(":programmeSlug", programmeSlug)
      .replace(":unitSlug", unitSlug)
      .replace(":lessonSlug", lessonSlug);
  return (
    <OakFlex
      $flexDirection="column"
      $rowGap={"spacing-48"}
      $ph={["spacing-16", "spacing-32", "spacing-48"]}
      $pv={["spacing-16", "spacing-32", "spacing-48"]}
    >
      <ListHeader
        backHref={programmeUrlTemplate.replace(":programmeSlug", programmeSlug)}
        tagLabel={`${browseData?.length ?? 0} lessons`}
        headerLeftSlot={headerLeftSlot}
        bulletListLabels={[
          `Year ${programmeFields?.year ?? ""}`,
          programmeFields?.pathway ?? undefined,
          programmeFields?.examboard ?? undefined,
          programmeFields?.tierDescription ?? undefined,
        ].filter((l) => l !== undefined)}
        title={hasOptionality ? programmeFields.optionality : unitData?.title}
        subheading={hasOptionality ? unitData?.title : undefined}
        description={unitData?.description}
        color={"bg-decorative4-main"}
      />
      <LessonList
        lessons={browseData}
        phase={programmeFields?.phase ?? ""}
        subject={programmeFields?.subject ?? ""}
        unitTitle={unitData?.title ?? ""}
        getPupilLessonUrl={getPupilLessonUrl}
        onLessonSelected={onLessonSelected}
        onLessonPreviewed={onLessonPreviewed}
      />
    </OakFlex>
  );
};
